import { render, staticRenderFns } from "./CurrentPackDetail.vue?vue&type=template&id=e308465c&scoped=true&"
import script from "./CurrentPackDetail.vue?vue&type=script&lang=js&"
export * from "./CurrentPackDetail.vue?vue&type=script&lang=js&"
import style0 from "./CurrentPackDetail.vue?vue&type=style&index=0&id=e308465c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e308465c",
  null
  
)

export default component.exports